<template>
	<div>
		<div v-if="loading" class="row">
			<LoadingSpinner class="col-12" />
		</div>
		<div v-else class="row">
			<div class="col-4">
	    		<label class="col-form-label">{{ $t('monte.congelation.destinataire_manuel') }}</label><br>
	    		{{ commande.semenceexpedition_destinataire_manuel }}<br>
        		{{ commande.semenceexpedition_destinataire_manuel_firstname }} {{ commande.semenceexpedition_destinataire_manuel_lastname }}<br>
        		{{ commande.semenceexpedition_destinataire_manuel_adress }}<br>{{ commande.semenceexpedition_destinataire_manuel_postalcode }} {{ commande.semenceexpedition_destinataire_manuel_town }}<br>
        		{{ commande.semenceexpedition_destinataire_manuel_mail }}<br>{{ commande.semenceexpedition_destinataire_manuel_tel }}
			</div>
			<div class="col">
				<div class="row">
					<div class="col-5">
			    		<label class="col-form-label">{{ $t('monte.congelation.destinataire') }} *</label>
						<SearchTiers
							v-if="reload_search_tiers"
							:tiers_selected.sync="form.destinataire"
							:preselected="form.destinataire"
							:with_tags="true"
						/>
					</div>
					<div class="col-auto pl-0 mt-3">
						<label>&nbsp;</label>
		                <b-button variant="secondary" block @click="openAddTier"><font-awesome-icon :icon="['far', 'plus']" /></b-button>
		            </div>
					<div class="col-6 mt-1">
						<label for="date">{{ $t("monte.congelation.date_expedition") }} *</label>
						<e-datepicker id="date" v-model="form.semenceexpedition_expedition_date" mode="date"></e-datepicker>
					</div>
					<div v-if="!commande.semenceexpedition_dose" class="col-6 mt-1 form-group">
						<label for="qte">{{ $t("monte.congelation.norme") }}</label>
						<e-select
							v-model="form.norme"
							id="protocole_id"
							track-by="protocole_id"
							label="protocole_label"
							:placeholder="$t('monte.congelation.selectionner_protocole')"
							:selectedLabel="$t('global.selected_label')"
							:options="protocoles"
							:searchable="true"
							:show-labels="false"
							:group-select="false"
						>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
						<span v-if="stock_available">{{ $t('monte.congelation.stock') }} : {{ stock_available.nb_stock }} - {{ $t('monte.congelation.stock_theorique') }} : {{ stock_available.nb_theorique }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="row mt-2">
	        <div class="col-12 text-center">
	            <b-button :disabled="stock_available && stock_available.nb_theorique <= 0" @click="save" variant="primary">{{ $t('action.valider') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" spin /><font-awesome-icon v-else :icon="['fal', 'check']" /></b-button>
	        </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
	import Shutter from '@/mixins/Shutter.js'
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"
    import Tiers from "@/mixins/Tiers.js"

	export default {
		name: 'ValidCommande',
		mixins: [Congelation, Shutter, ShutterCongelation, Tiers],
		props: ['commande'],
		data () {
			return {
				form: {
					norme: null,
					destinataire: null,
					semenceexpedition_expedition_date: new Date
				},
				processing: false,
				reload_search_tiers: true,
				loading: false,
				protocoles: [],
				stock_available: null
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.stock_available = null
				this.loading = true
				this.form.destinataire = {...this.commande.destinataire}
				if(!Object.prototype.hasOwnProperty.call(this.form.destinataire, 'tiers_id')) {
					this.form.destinataire.tiers_rs = ''
				}
				this.form.semenceexpedition_expedition_date = new Date(this.commande.semenceexpedition_expedition_date)
				this.protocoles = await this.getAllProtocoles()
				this.loading = false
			},

			async save() {
				if(!this.form.destinataire || !this.form.semenceexpedition_expedition_date || this.processing || (this.stock_available && this.stock_available.nb_theorique <= 0)) {
					return false
				}
				const protocole_id = this.form.norme ? this.form.norme.protocole_id : null
				this.processing = true
				await this.valideExpedition(this.commande.semenceexpedition_id, this.form.destinataire.tiers_id, this.form.semenceexpedition_expedition_date, protocole_id)
				this.processing = false
				this.successToast('toast.info_save_succes')
				this.ok()
				this.shutterPanel().close('valid-commande')
			},

			openAddTier() {
				this.setupAddTier(this.reloadTiers)
			},

			async reloadTiers(tiers_id) {
				this.shutterPanel().goTo('valid-commande')
				this.reload_search_tiers = false
				this.form.destinataire = await this.loadTier(tiers_id)
				this.reload_search_tiers = true
			},

			preselectProtocole() {
				if(this.form.destinataire && !this.form.norme) {
					const norme = this.protocoles.find(p => p.protocole_countries && p.protocole_countries.includes(this.form.destinataire.tiers_country))
					if(norme) {
						this.form.norme = norme
					}
				}
			},

			async loadStocks() {
				this.stock_available = null
				if(this.commande.demandeur) {
					const protocole = this.form.norme ? this.form.norme.protocole_id : ''
					this.stock_available = await this.getLotsAvailable(this.commande.stallion.horse_id, this.commande.demandeur.tiers_id, protocole, this.commande.semenceexpedition_id)
				}
			}
		},

		watch: {
			'commande.semenceexpedition_id'() {
				this.init_component()
			},

			'form.destinataire' () {
				this.preselectProtocole()
			},

			'form.norme' () {
				this.loadStocks()
			},

			'form.semenceexpedition_expedition_date' () {
				this.loadStocks()
			}
		},

		components: {
			SearchTiers : () => import('@/components/Contract/SearchTiers'),
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>